export default __webpack_public_path__ + "static/media/glassesRight.795567e3.svg";